import {Navigate} from "react-router-dom";

import {useStoredMe} from "@/src/modules/core/store/me";

import {shiftsService} from "../services";

export default function ShiftsManagementGuard({children}: {children: React.ReactNode}) {
  const me = useStoredMe();

  if (!shiftsService.getCanAccessShiftsManagement(me)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
